/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */

export class Task {
    names = {};
    static getTask(name) {
      if (!Task.names[name]) {
        Task.names[name] = new Task(name);
      }

      return Task.names[name];
    }

    constructor(name) {
      this.name = name;
      this.list = null;
      this.nextTask = null;
      this._job = null;
      this._end = () => {
        this.list.handleOver(this);
      };
    }

    set job(val) {
      this._job = (...params) => {
        console.log(`${this.name}is doing job`);
        val(...params);
      };
    }

    get job() {
      return this._job;
    }

    set end(val) {
      this._end = val;
    }

    get end() {
      return this._end;
    }
}
export class TaskList {
  static getInstance() {
    if (!TaskList.instance) {
      TaskList.instance = new TaskList();
    }

    return TaskList.instance;
  }

  constructor() {
    this.list = [];
    this.names = {};
  }

  addTask(task) {
    if (this.names[task.name]) {
      return;
    }

    if (this.list.length === 0) {
      task.job.call(task);
    }

    this.list.push(task);
    this.names[task.name] = task;
    task.list = this;
  }

  handleOver(task) {
    for (let i = 0; i < this.list.length; i++) {
      if (task === this.list[i]) {
        this.list.splice(i, 1);
        // remove task
        this.names[task.name] = null;
      }
    }


    const newtask = this.list[0];
    if (newtask) {
      setTimeout(() => newtask.job.call(newtask), 500);
    }
  }
}
